/**
 * Processes a single document from API (get resource) into a file with id.
 * Shared by pensioners createUpdateConfig and profile useCreateUpdateConfig.
 * @function
 *
 * @param {Object} doc - Document from API ({ _id, type }).
 * @param {function} createFileFromJSON - Function(id, dispatchAPI, message) => Promise.
 * @param {function} dispatchAPI - API dispatch.
 * @param {function} message - Error message handler.
 * @returns {Promise<{ type: string, file: Object }>} - { type, file } for aggregation by caller.
 */
export const processOneDocumentForGetResource = async (
  doc,
  createFileFromJSON,
  dispatchAPI,
  message
) => {
  if (doc.type === 'other_documents') {
    const otherDocument = await createFileFromJSON(
      doc._id,
      dispatchAPI,
      message
    );
    otherDocument.file.id = otherDocument._id;
    return { type: doc.type, file: otherDocument.file };
  }
  const file = await createFileFromJSON(doc._id, dispatchAPI, message);
  file.file.id = file._id;
  return { type: doc.type, file: file.file };
};
